// extracted by mini-css-extract-plugin
export var category = "styles-module--category--afca2";
export var layout = "styles-module--layout--49fd6";
export var link = "styles-module--link--e29d3";
export var links = "styles-module--links--8b2d1";